import React, { useEffect, useState } from 'react'
import './Hero.css'

const getVideoSrc = () =>
  window.innerWidth / window.innerHeight < 1
    ? '/assets/videos/video-9-16.mp4'
    : '/assets/videos/video-16-9.mp4'

const Hero = () => {
  const [videoLoaded, setVideoLoaded] = useState(false)
  const [videoPlaying, setVideoPlaying] = useState(false)
  const [videoSrc, setVideoSrc] = useState(getVideoSrc)

  useEffect(() => {
    const handleResize = () => {
      setVideoSrc(getVideoSrc())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    const handleLoad = () => {
      setVideoLoaded(true)
    }

    if (document.readyState === 'complete') {
      handleLoad()
    } else {
      window.addEventListener('load', handleLoad)
      return () => window.removeEventListener('load', handleLoad)
    }
  }, [])

  return (
    <section className={`hero${videoPlaying ? ' hero--playing' : ''}`}>
      <video 
        className="hero-video" 
        autoPlay 
        loop 
        muted 
        playsInline
        poster="/assets/videos/thumbnail.jpg"
        key={videoSrc}
        onPlay={() => setVideoPlaying(true)}
      >
        {videoLoaded && <source src={videoSrc} type="video/mp4" />}
      </video>
      {!videoPlaying && (
        <img
          className="hero-loading"
          src="/assets/images/loading.png"
          alt="Loading"
        />
      )}
    </section>
  )
}

export default Hero
